/**
 * @file Square button with Bootstrap icon that opens UserPanel in a modal
 * @version 1.0.0
 * @since 2025-08-25
 */

import UserAuthButtons from './UserAuthButtons.js';
import UserData from './UserData.js';
import ConfigEditor from '../../configs/components/ConfigEditor.js';
import UserPanel from './UserPanel.js';
import { useUser } from '../composables/user.js';

export default {
  name: 'UserButton',

  inheritAttrs: false,

  components: {
    UserAuthButtons,
    UserData,
    ConfigEditor,
    UserPanel,
  },

  template: `
    <div class="dropdown">
      <!-- Trigger Button -->
      <button 
        type="button" 
        class="btn"
        :class="Object.values($attrs).length ? '' : 'btn-secondary'"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        v-bind="$attrs"
      > 
        <i class="bi-person-circle"></i>
        <span v-if="showUserName && user.loggedIn" class="ms-2">
          {{ user.name }}
        </span>
      </button>
      
      <!-- Dropdown Menu -->
      <ul class="dropdown-menu dropdown-menu-end p-0" style="min-width: 400px;" @click.stop>
        <li class="p-3">
          <UserData />
        </li>
        <li><hr class="dropdown-divider"></li>
        <li class="px-3 py-2 d-flex justify-content-end align-items-center gap-2">
          <button
            class="btn btn-outline-secondary"
            data-bs-toggle="modal"
            data-bs-target="#userPanelModal"
          >
            <i class="bi bi-three-dots-vertical"></i>
          </button>
          <button
            v-if="user.configSchema"
            class="btn btn-outline-secondary"
            data-bs-toggle="modal"
            data-bs-target="#userSettingsModal"
          >
            <i class="bi bi-gear me-1"></i>
            Settings
          </button>
          <UserAuthButtons />
        </li>
      </ul>

      <!-- User Panel Modal -->
      <div class="modal fade" id="userPanelModal" tabindex="-1" aria-labelledby="userPanelModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="userPanelModalLabel">User Management</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <UserPanel />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Settings Modal (only if configSchema exists) -->
      <div v-if="user.configSchema" class="modal fade" id="userSettingsModal" tabindex="-1" aria-labelledby="userSettingsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="userSettingsModalLabel">User Settings</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <ConfigEditor config-name="_config" mode="edit" />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  props: {
    showUserName: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const user = useUser();

    return {
      user,
    };
  },
};
